import { mortgageConfig } from './config';

export interface IMortgageCalculatorInitialState {
  propertyCost: number;
  downPayment: number;
  creditTerm: number;
  rate: number;
}

export enum EMortgageCalculatorType {
  PropertyCostChange = 'PropertyCostChange',
  DownPaymentChange = 'DownPaymentChange',
  CreditTermChange = 'CreditTermChange',
  RateChange = 'RateChange',
}

interface IMortgageCalculatorAction {
  type: EMortgageCalculatorType;
  payload: number;
}

export const initialState = {
  propertyCost: mortgageConfig.propertyCost.defaultValue,
  downPayment: mortgageConfig.downPayment.defaultValue,
  creditTerm: mortgageConfig.creditTerm.defaultValue,
  rate: mortgageConfig.rate.defaultValue,
};

export function reducer(state: IMortgageCalculatorInitialState, action: IMortgageCalculatorAction) {
  switch (action.type) {
    case EMortgageCalculatorType.PropertyCostChange:
      return { ...state, propertyCost: action.payload };

    case EMortgageCalculatorType.DownPaymentChange:
      return { ...state, downPayment: action.payload };

    case EMortgageCalculatorType.CreditTermChange:
      return { ...state, creditTerm: action.payload };

    case EMortgageCalculatorType.RateChange:
      return { ...state, rate: action.payload };

    default:
      return state;
  }
}
